import { parseAttachmentFilename } from '../attachment-response'
import { apiClient } from '../config'

import type { GdprDeletionPreview, GdprDeletionSummary } from '../types'

export const gdprService = {
  exportUserData: async (userId: string): Promise<{ blob: Blob; filename: string }> => {
    const response = await apiClient.get<Blob>(`/gdpr/users/${userId}/export`, {
      responseType: 'blob',
    })

    return {
      blob: response.data,
      filename: parseAttachmentFilename({
        contentDisposition: response.headers['content-disposition'],
        fallbackFilename: `gdpr-export-${new Date().toISOString().split('T')[0]}.zip`,
      }),
    }
  },

  previewUserDeletion: async (userId: string): Promise<GdprDeletionPreview> => {
    const response = await apiClient.get<GdprDeletionPreview>(`/gdpr/users/${userId}/preview`)
    return response.data
  },

  deleteUserForGdpr: async (userId: string): Promise<GdprDeletionSummary> => {
    const response = await apiClient.delete<GdprDeletionSummary>(`/gdpr/users/${userId}`)
    return response.data
  },
}
